import { actionTypes } from './constants';
import { getApiActionCreator } from 'helpers/actionHelper';

export const getMaintenanceScheduleAction = getApiActionCreator(actionTypes.GET_MAINTENANCE_SCHEDULE_SETTINGS);
export const addMaintenanceScheduleAction = getApiActionCreator(actionTypes.ADD_MAINTENANCE_SCHEDULE_SETTINGS);

export const getMaintenanceSchedule = (organizationID) => ({
	type: actionTypes.GET_MAINTENANCE_SCHEDULE_REQUEST,
	organizationID
});

export const addMaintenanceSchedule = (
	organizationId,
	scheduleId,
	microServiceScheduleData,
	isForSave
) => ({
	type: actionTypes.ADD_MAINTENANCE_SCHEDULE_REQUEST,
	organizationId,
	scheduleId,
	microServiceScheduleData,
	isForSave
});

export const clearStore = () => {
	return (dispatch) => {
		dispatch({ type: actionTypes.CLEAR_STORE });
	};
};

export const getMicroServiceScheduleData = (scheduleData) => ({
	type: actionTypes.GET_MAINTENANCE_SCHEDULE_SETTINGS_MICRO_SERVICE,
	scheduleData
});
